import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';

import orange40Polygon from '../assets/images/svg/orange-polygon.svg';
import purplePolygon from '../assets/images/svg/purple-polygon.svg';

import Decisions from 'routes/decision-trees/components/Decisions';
import QSBSPopups from '../components/popups/QSBSPopups';

const IsoG = ({ setCurrentPage }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openQSBSPopup = () => setIsPopupOpen(true);

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoC'), []);

  const yesHandler = () => setCurrentPage('isoH');
  const noHandler = () => setCurrentPage('isoI');

  const firstCaseContent = (
    <>
      <h3>Yes</h3>
      <p>my shares meet all requirements and are QSBS.</p>
    </>
  );
  const secondCaseContent = (
    <>
      <h3>No</h3>
      <p>my shares do not meet one or more of the requirements for QSBS.</p>
    </>
  );

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <h1 className='page-heading text-center mb-5'>
        Do your shares meet the requirements to be classified as{' '}
        <span className='color-yellow c-pointer' onClick={openQSBSPopup}>
          qualified small business stocks (QSBS)
        </span>
        ?
      </h1>

      <Decisions
        firstCaseContent={firstCaseContent}
        secondCaseContent={secondCaseContent}
        firstCaseBackground={orange40Polygon}
        secondCaseBackground={purplePolygon}
        firstCaseHandler={yesHandler}
        secondCaseHandler={noHandler}
      />

      <QSBSPopups isQSBSPopupOpen={isPopupOpen} setIsQSBSPopupOpen={setIsPopupOpen} />
    </div>
  );
};

IsoG.propTypes = {
  setCurrentPage: PropTypes.func
};

export default IsoG;
